export const TYPE_TO_COLOR = {
  success: 'var(--color-success, #4caf50)',
  error: 'var(--color-error, #f44336)',
  warning: 'var(--color-warning, #ff9800)',
  primary: 'var(--primary-color,rgb(90, 134, 179))',
}

export const BASE_PAGE_NAME = 'OKG'

export const OKGPORTAL_URL='https://plans.api.okgnn.ru/api'

export const MONTH = [
  "Январь",
  "Февраль",
  "Март",
  "Апрель",
  "Май",
  "Июнь",
  "Июль",
  "Август",
  "Сентябрь",
  "Октябрь",
  "Ноябрь",
  "Декабрь",
];

export enum UserRole {
  EMPLOYEE = 'employee',
  HEADER = 'header'
}